export const Countries = {
      "United States": "2397",
      "Afghanistan": "2199",
      "Aguascalientes (Mexico)": "2200",
      "Albania": "2196",
      "Alberta (Canada)": "1053",
      "Algeria": "2203",
      "All Others": "2411",
      "Andorra": "2198",
      "Angola": "2204",
      "Anguilla (UK)": "6066",
      "Antigua and Barbuda": "2201",
      "Argentina": "2207",
      "Armenia": "6068",
      "Aruba (Neth Antilles)": "6067",
      "Ashmore and Cartier Islands (Australia)": "6225",
      "Australia": "2206",
      "Austria": "2208",
      "Azerbaijan": "6069",
      "Azores Islands": "6197",
      "Bahamas, The": "2212",
      "Bahrain": "2213",
      "Baja California (Mexico)": "2210",
      "Baja California Sur (Mexico)": "2217",
      "Balearic Islands": "6200",
      "Bangladesh": "6070",
      "Barbados": "2211",
      "Bassas Da India (France)": "6201",
      "Belarus, Republic of": "6073",
      "Belgium": "2214",
      "Belize( frmr. British Honduras)": "2215",
      "Benin (fmr. Dahomey)": "6071",
      "Bermuda": "2218",
      "Bhutan": "2219",
      "Bolivia": "2223",
      "Bosnia and Herzegovina": "6034",
      "Botswana": "2221",
      "Bouvet Island (Norway)": "6202",
      "Brazil": "2225",
      "British Columbia (Canada)": "1054",
      "British Indian Ocean Territory (UK)": "6203",
      "British Virgin Islands": "6072",
      "Brunei": "2224",
      "Bulgaria": "2222",
      "Burkina Faso (fmr. Upper Volta)": "6175",
      "Burma": "2220",
      "Burundi": "2216",
      "Cambodia": "2234",
      "Cameroon": "2237",
      "Campeche (Mexico)": "2229",
      "Canada": "2228",
      "Canary Islands": "6204",
      "Cape Verde": "2244",
      "Caroline Islands": "2231",
      "Cayman Islands (UK)": "2239",
      "Central African Republic": "2245",
      "Chad": "2230",
      "Chiapas (Mexico)": "2233",
      "Chihuahua (Mexico)": "2232",
      "Chile, Republic of": "2240",
      "China, Peoples Republic of": "2238",
      "Christmas Island (Australia)": "6074",
      "Clipperton Island": "6205",
      "Coahuila (Mexico)": "2243",
      "Cocos Islands (Australia)": "6075",
      "Colima (Mexico)": "2236",
      "Colombia": "2226",
      "Comoros, Federal Islamic Republic of": "6076",
      "Congo": "2246",
      "Cook Islands": "6077",
      "Coral Sea Islands (Australia)": "6220",
      "Costa Rica, Republic of": "2241",
      "Côte d`Ivoire (fmr. Ivory Coast)": "2294",
      "Croatia": "6078",
      "Cuba, Republic of": "2227",
      "Cyprus": "2242",
      "Czec Republic": "6079",
      "Czechoslovakia": "2235",
      "Dahomey (now Benin)": "2250",
      "Democratic Republic Congo": "6080",
      "Denmark": "2251",
      "Distrito Federal (Mexico, D.F.": "2249",
      "Djibouti, Republic of": "6081",
      "Dominica": "2252",
      "Dominican Republic": "2254",
      "Durango (Mexico)": "2253",
      "East Germany": "2258",
      "Ecuador": "2261",
      "Egypt": "2262",
      "El Salvador": "2257",
      "England": "2259",
      "Equatorial Guinea": "2256",
      "Eritrea": "6082",
      "Estonia": "2260",
      "Ethiopia": "2255",
      "Europa Island (France)": "6206",
      "Falkland Islands": "6083",
      "Faroe Islands": "6207",
      "Fiji Islands": "2264",
      "Finland": "2263",
      "France": "2265",
      "French Guiana": "6084",
      "French Polynesia (France)": "6085",
      "French Southern & Antarctic Lands": "6086",
      "Gabon": "2267",
      "Gambia": "2273",
      "Gaza": "6226",
      "Georgia (fmr. Gruzinskaya)": "6087",
      "Germany": "2269",
      "Ghana": "2270",
      "Gibraltar": "6088",
      "Glorioso Islands (France)": "6208",
      "Greece": "2268",
      "Greenland": "2275",
      "Grenada": "2272",
      "Guadeloupe, Department of": "2276",
      "Guam": "2274",
      "Guanajuato (Mexico)": "2279",
      "Guatemala": "2278",
      "Guernsey, Bailiwick of": "6198",
      "Guerrero (Mexico)": "2277",
      "Guiana/Guyana": "2280",
      "Guinea": "2271",
      "Guinea Bissau": "6089",
      "Haiti": "2284",
      "Heard Island and McDonald Islands, Territory of": "6227",
      "Hidalgo (Mexico)": "2283",
      "Honduras": "2281",
      "Hong Kong": "2282",
      "Hungary": "2285",
      "Iceland": "2286",
      "India": "2288",
      "Indonesia": "2289",
      "Iran": "2291",
      "Iraq": "2290",
      "Ireland": "2287",
      "Isle of Man (UK)": "6209",
      "Israel": "2292",
      "Italy": "2293",
      "Jalisco (Mexico)": "2296",
      "Jamaica": "2297",
      "Jan Mayen (Norway)": "6210",
      "Japan": "2295",
      "Jersey, Bailiwick of": "6199",
      "Jordan": "2298",
      "Juan de Nova Island": "6211",
      "Kazakhstan": "6091",
      "Kenya": "2299",
      "Kiribati": "6092",
      "Korea": "2300",
      "Kosovo": "6228",
      "Kuwait": "2301",
      "Kyrgyzstan": "6212",
      "Laos": "2307",
      "Latvia": "2308",
      "Lebanon": "2306",
      "Lesotho": "2303",
      "Liberia": "2302",
      "Libya": "2310",
      "Liechtenstein": "2305",
      "Lithuania": "2304",
      "Luxembourg": "2309",
      "Macau": "6094",
      "Macedonia": "6093",
      "Madeira Islands": "6213",
      "Malagasy Republic (inc. Madagascar)": "2320",
      "Malawi": "2312",
      "Malaysia": "2328",
      "Maldives": "2324",
      "Mali": "2317",
      "Malta": "2327",
      "Manahiki Island": "6214",
      "Manitoba (Canada)": "1055",
      "Marianas Islands": "2316",
      "Marshall Islands": "2314",
      "Martinique": "2413",
      "Mauritania": "2323",
      "Mauritius": "6095",
      "Mayotte": "6177",
      "Mexico": "2318",
      "Mexico, State of (Mexico)": "2326",
      "Michoacan (Mexico)": "2311",
      "Micronesia, Federated States": "6096",
      "Midway Islands": "2325",
      "Moldova": "6215",
      "Monaco": "2315",
      "Mongolia": "2313",
      "Montenegro": "2202",
      "Montserrat (UK)": "6097",
      "Morelos (Mexico)": "2322",
      "Morocco": "2321",
      "Mozambique": "6098",
      "Nauru": "2337",
      "Nayarit (Mexico)": "2329",
      "Nepal": "2335",
      "Netherlands": "2338",
      "Netherlands Antilles": "2341",
      "Neuvo Leon (Mexico)": "2332",
      "New Brunswick (Canada)": "1056",
      "New Caledonia": "2336",
      "New Guinea": "2334",
      "New Zealand": "2342",
      "Newfoundland and Labrador (Canada)": "1057",
      "Nicaragua": "2339",
      "Niger": "2333",
      "Nigeria": "2330",
      "Niue": "6099",
      "Norfolk Island, Territory of": "6221",
      "North Korea": "6100",
      "North Vietnam": "6260",
      "Northern Ireland": "2331",
      "Northwest Territories (Canada)": "1058",
      "Norway": "2340",
      "Nova Scotia (Canada)": "1059",
      "Nunavut": "1060",
      "Oaxaca (Mexico)": "2343",
      "Okinawa": "6216",
      "Oman": "6101",
      "Ontario (Canada)": "1061",
      "Pakistan": "2347",
      "Palau": "6102",
      "Panama": "2348",
      "Panama Canal Zone (US)": "2248",
      "Paracel Islands": "6229",
      "Paraguay": "2352",
      "Peru": "2351",
      "Philippines": "2346",
      "Pitcairn Island": "2345",
      "Poland": "2349",
      "Portugal": "2350",
      "Prince Edward Island (Canada)": "1062",
      "Puebla (Mexico)": "2344",
      "Qatar": "2353",
      "Quebec (Canada)": "1063",
      "Queretaro (Mexico)": "2355",
      "Quintana Roo (Mexico)": "2354",
      "Reunion": "2356",
      "Rhodesia": "2357",
      "Rumania": "2358",
      "Russia": "6255",
      "Russian Federation": "6104",
      "Rwanda": "2359",
      "San Luis Potosi (Mexico)": "2369",
      "San Marino": "2365",
      "Sao Tome and Principe": "6107",
      "Saskatchewan (Canada)": "1064",
      "Saudi Arabia": "2361",
      "Scotland": "2375",
      "Senegal": "2364",
      "Serbia": "6103",
      "Seychelles": "2362",
      "Sierra Leone": "2360",
      "Sikkim": "2368",
      "Sinaloa (Mexico)": "2366",
      "Singapore": "2374",
      "Slovak Republic/Slovikia": "6108",
      "Slovenia": "6109",
      "Solomon Islands": "6110",
      "Somalia": "2370",
      "Sonora (Mexico)": "2371",
      "South Africa": "2363",
      "South Georgia and the South Sandwich Islands": "6219",
      "South Korea": "6105",
      "South Vietnam": "6261",
      "Southern Yemen": "2376",
      "South-West Africa (fmr. Namibia)": "2367",
      "Soviet Union": "2380",
      "Spain": "2372",
      "Spratly Islands": "6231",
      "Sri Lanka (fmr. Ceylon)": "2247",
      "St. Kitts/Nevis": "6112",
      "St. Lucia": "6113",
      "St. Pierre and Miquelon": "6114",
      "St. Vincent and the Grenadines": "6115",
      "St.Helena": "6111",
      "Sudan": "2377",
      "Surinam": "2414",
      "Svalbard": "2378",
      "Swaziland": "2379",
      "Sweden": "2373",
      "Switzerland": "2382",
      "Syria": "2381",
      "Tabasco (Mexico)": "2384",
      "Taiwan, Republic of China": "6116",
      "Tajikistan": "6117",
      "Tamaulipas (Mexico)": "2383",
      "Tanzania": "2394",
      "Thailand": "2387",
      "Tlaxcala (Mexico)": "2388",
      "Togo": "2390",
      "Tokelau": "6222",
      "Tonga": "2386",
      "Tongareva": "6223",
      "Trinidad And Tobago": "2391",
      "Tromelin Island": "6224",
      "Trucial States": "2385",
      "Trust Territory of the Pacific Islands": "6230",
      "Tuamotu Archipelago": "6257",
      "Tunisia": "2392",
      "Turkey": "2393",
      "Turkmenistan": "6118",
      "Turks and Caicos Islands": "6119",
      "Tuvalu": "6120",
      "Uganda": "2396",
      "Ukraine": "6036",
      "United Arab Republic": "2395",
      "United Kingdom": "6178",
      "Unknown": "6258",
      "Uruguay": "2399",
      "Uzbekistan": "6121",
      "Vanuatu, Republic of (fmr. New Hebrides)": "6217",
      "Vatican City/Holy See": "6090",
      "Venezuela": "2402",
      "Veracruz (Mexico)": "2400",
      "Vietnam": "6259",
      "Vietnam, Socialist Republic": "2401",
      "Wake Island": "2404",
      "Wales": "2405",
      "Wallis and Futuna Islands": "6122",
      "West Bank": "6176",
      "West Germany": "2403",
      "West Indies": "2406",
      "Western Sahara": "6123",
      "Western Samoa": "2407",
      "Yemen": "2408",
      "Yemen Arab Republic": "6266",
      "Yucatan (Mexico)": "2410",
      "Yugoslavia": "2409",
      "Yukon (Canada)": "1065",
      "Zacatecas (Mexico)": "2412",
      "Zaire, Republic of (fmr. Congo)": "6218",
      "Zambia": "2415",
      "Zimbabwe": "6138"
}


// WEBPACK FOOTER //
// ./src/utils/countries.js